<script>
import { Card } from 'vant';
import { Image as VanImage } from 'vant';
import { Switch } from 'vant';
import { Col, Row } from 'vant';
import { formatDateToYYYYMMDD, formatDateTime } from '@/ultis/dateFormat';

export default {
  props: {
    handleIsShowConfirm: {
      type: Function,
      required: false
    },
    data: {
      type: Object,
      required: true
    },
    showRenew: {
      type: Boolean,
      required: false
    },
    showStatus: {
      type: Boolean,
      required: false
    },
    showExpired: {
      type: Boolean,
      required: false
    },
    type: {
      type: String,
      required: true
    },
    package_active: {
      type: String,
      required: false
    }
  },
  components: {
    [Card.name]: Card,
    [Image.name]: Image,
    [VanImage.name]: VanImage,
    [Switch.name]: Switch,
    [Col.name]: Col,
    [Row.name]: Row
  },
  data() {
    return {
      checked: false,
      styleObject: {
        border: '1px solid rgb(196, 22, 39)'
      }
    };
  },
  mounted() {
    this.checked = this.data.renew;
  },
  watch: {},
  methods: {
    processPhoneNumber(phoneNumber) {
      if (phoneNumber.startsWith("855")) {
        phoneNumber = phoneNumber.replace(/^\855/, '0');
      }

      return phoneNumber;
    },
    formatDateToYYMMDD(input, type) {
      if (type == "date") {
        return formatDateToYYYYMMDD(input)
      }
      if (type == "time") {
        return formatDateTime(input)
      }
      return "";
    },
    handleRenewPackage() {
      if (this.data && !this.data.renew)
        return;
      this.$emit('handleIsShowConfirm')
    },
    fixedPrice(price) {
      if (price) {
        return price.toFixed(2);
      }
      return price;
    },
  }
};
</script>
<template>
  <div>
    <van-card :thumb="data.iconUrl" class="van-card-post"
      :style="package_active && package_active == data.serviceCode ? styleObject : ''">
      <template #tags>
        <van-row>
          <van-col span="24">
            <div>
              <div class="d-flex van-row--justify-space-between van-row--align-center">
                <h3 class="van-card__title" v-if="type == 'home'"> {{ data.serviceName }}</h3>
                <h3 class="van-card__title" v-if="type == 'history' || type == 'myservices'"> {{
                  data.subServiceName
                }}</h3>
                <van-switch v-if="showRenew" class="van-switch-post" @click="handleRenewPackage()"
                  :model-value="data.renew" />
                <div class="van-switch-post" v-if="data.errorCode != null">
                  <span class="badge badge-success" v-if="data.errorCode == '0'"> {{ $t("success") }}</span>
                  <span v-else class="badge badge-danger">{{ $t("failed") }}</span>
                </div>
              </div>
              <p class="van-card__desc"> {{ data.shortDes }}</p>
            </div>
            <div class="d-flex align-items-center cs-van-tag">
              <van-tag plain type="danger" class="van-tag-icon">
                <div class="currency-unit-box">
                  <p class="currency-unit">{{ data.unit }}</p>
                </div>
              </van-tag>
              <van-tag plain type="danger" class="van-tag-price"> {{ fixedPrice(data.price) }}</van-tag>
              <van-tag plain type="danger" class="van-tag-day">/ {{ data.validity }}</van-tag>
            </div>
            <p v-if="showExpired && type == 'history' && data.phoneNumber" class=""
              style="display: flex; margin: 0px 0px 5px 0px">
              <van-icon name="phone" color="#005d85" size="14" />
              <span style="margin-left: 5px; color: #272D37"> 0{{ data.phoneNumber }}</span>
            </p>
            <p v-if="showExpired && type == 'history'" class="van-card__expired"> {{ $t("package_register") }}:
              {{ formatDateToYYMMDD(data.registerDate, "time") }}</p>
            <p v-if="showExpired && type == 'myservices'" class="van-card__expired"> {{ $t("package_expired") }}:
              {{ formatDateToYYMMDD(data.expiredDate, "date") }}</p>
          </van-col>
        </van-row>
      </template>
    </van-card>
  </div>
</template>

<style>
.currency-unit-box {
  margin: 0;
  width: 14px;
  height: 14px;
  background: #FDB913;
  border-radius: 50%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
}

.currency-unit {
  margin: 0;
  color: #fff;
  font-size: 11px;
}

.van-card-post {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  border: 1px solid #EAEBF0;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);
}

.van-card-post .van-card__header {
  align-items: start;
}

.van-card-post .van-card__title {
  font-size: 16px;
  font-weight: 700;
  line-height: 19.09px;
  margin: 0px;
  margin-bottom: 4px;
}

.van-card-post .van-card__desc {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.32px;
  margin: 0;
  padding: 4px 0px;
  color: #272D37;
  width: 100%;
  max-height: fit-content;
}

.van-card-post .cs-van-tag {
  margin-bottom: 4px;
}

.van-card-post .van-card__expired {
  margin: 0;
  margin-bottom: 4px;
  color: #FDB913;
  font-size: 12px;
  font-weight: 400;
}

.van-card-post .van-card__thumb {
  width: 56px;
  height: 56px;
}

.van-card-post .van-card__content {
  justify-content: center;
  min-height: fit-content;
}

.img-price {
  width: 14px;
  height: 14px;
  fill: #FDB913;
}

.van-tag-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.van-tag-price {
  font-size: 14px;
  font-weight: bold;
  color: #FDB913;
}

.van-tag-day {
  color: #272D37;
  font-size: 12px;
  font-weight: 500;
}

.van-switch-post.van-switch {
  height: 18px;
  width: 59.5px;
  background: #BEBEBE;
  position: relative;
}

.van-switch-post.van-switch.van-switch--on {
  background: #0D993D;
}

.van-switch-post.van-switch .van-switch__node {
  width: 15px;
  height: 15px;
  top: 1px;
  left: 2px;
}

.van-switch-post.van-switch--on.van-switch::before {
  left: 5px;
}

.van-switch-post.van-switch::before {
  content: "renew";
  display: block;
  font-size: 12px;
  position: absolute;
  top: 1.5px;
  right: 5px;
  color: #fff;
}

.van-switch-post.van-switch--on.van-switch .van-switch__node {
  left: 12px;
}

.van-switch {
  position: relative;
}

.van-switch .right:before {
  content: "renew";
  display: block;
  font-size: 12px;
  position: absolute;
  top: 2px;
  left: 3px;
}

.van-switch .left :before {
  content: "renew";
  display: block;
  font-size: 12px;
  position: absolute;
  top: 2px;
  right: -38px;
}

.badge {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
}

.badge.badge-success {
  background: rgba(91, 182, 115, 0.16) !important;
  color: #2A7D42 !important;
  padding: 6px 10px !important;
  border-radius: 999px !important; 
}

.badge.badge-danger {
  background: rgba(224, 89, 85, 0.16) !important;
  color: #C92824 !important;
  padding: 6px 10px !important;
  border-radius: 999px !important; 
}
</style>
